import { use, useContext } from "react";
import {
    type DayjsConstructor,
    dayjsFactory,
} from "../../app/common/setupDayjs";
import { DayjsContext } from "./index";

export function useDayjs(): DayjsConstructor {
    const context = useContext(DayjsContext);

    if (!context) {
        throw new Error("useDayjs must be used within a DayjsContext");
    }

    let locale;
    if (context.locale instanceof Promise) {
        locale = use(context.locale);
    } else {
        locale = context.locale;
    }

    return dayjsFactory(locale);
}
